// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__nlkF+","sidebar-links":"sidebar_sidebar-links__IJilw","nav-link":"sidebar_nav-link__J73-Y"};